module.exports = __webpack_public_path__ + "img/historical_route.2e5e7ede.png";